<!-- new-alert popup (on add new alert button of alert notification popup) -->
<div id="forScroll" class="popup-bg ">
    <div class="popup popup-newalert">
        <div class="popup-content">
            <h3>New Alert</h3>
            <div class="alert-error" *ngIf="errorMessage">{{errorMessage}}</div>
            <div class="alert-success" *ngIf="successMessage">{{successMessage}}</div>
            <div class="alert-warning" *ngIf="warningMessage">{{warningMessage}}</div>
            <form class="form-wrap" [formGroup]="addAlert">
                <div class="input-row input-row-wide">
                    <div class="input-wrap">

                        <div class="type-text">
                            <span class="input-title">New Alert <em> *</em></span>
                        </div>
                        <input type="text" placeholder="Add New Alert" formControlName="alertName">
                    </div>
                </div>


                <span class="alert-me">Alert me when</span>


                <div class="input-row input-row-wide">
                    <div class="input-wrap">

                        <div class="type-text">
                            <span class="input-title">KPI Type <em> *</em></span>
                        </div>
                        <div class="dropdown-wrap" [ngClass]="{'disable-input':!globalService.kpiType}">
                            <app-form-select-box [options]="globalService.kpiType" [dropDownIdKey]="'id'" [dropdownLabel]="'list'" [isDefaultOptionShowHidden]="'false'" [formElementName]="addAlert" [controlName]="'kpiType_select_name'" [currentSelectedValue]="addAlert['controls']['kpiType']['value']"
                                (currentSelectionChange)="changeSelection($event)">
                            </app-form-select-box>
                        </div>
                    </div>
                    <div class="input-wrap">

                        <div class="type-text">
                            <span class="input-title">KPI <em> *</em></span>
                        </div>

                        <div class="dropdown-wrap">
                            <app-form-select-box [options]="kpiList && kpiList.length>0?kpiList:globalService.kpiList" [dropDownIdKey]="'id'" [dropdownLabel]="'list'" [formElementName]="addAlert" [controlName]="'kpi_select_name'" [addCurrentSelectedValue]="false" (currentSelectionChange)="changeSelection($event)">
                            </app-form-select-box>
                        </div>
                    </div>
                    <div class="input-wrap">
                        <div class="type-text">
                            <span class="input-title">Condition <em> *</em></span>
                        </div>
                        <div class="dropdown-wrap">
                            <app-form-select-box [id]="'condition'" [options]="conditionList" [dropDownIdKey]="'id'" [dropdownLabel]="'list'" [formElementName]="addAlert" [controlName]="'condition_select_name'" [addCurrentSelectedValue]="false" (currentSelectionChange)="changeSelection($event)">
                            </app-form-select-box>
                        </div>
                    </div>

                </div>
                <div class="input-row input-row-wide">
                    <div class="input-wrap">

                        <div class="type-text">
                            <span class="input-title">Value <em> *</em></span>
                        </div>
                        <div class="dropdown-wrap">
                            <input type="number" min="1" max="4" formControlName="value">
                            <!-- <app-form-select-box [id]="'deviceCategory_fk'" [options]="globalService.organisationOptions"
                            [dropDownIdKey]="'deviceCategory_id'" [dropdownLabel]="'deviceCategory'"
                            [formElementName]="addAlert" [controlName]="'deviceCategory_select_name'"
                            [addCurrentSelectedValue]="false"
                            (currentSelectionChange)="changeSelection($event)">
                        </app-form-select-box> -->
                        </div>
                    </div>
                    <div class="input-wrap">

                        <div class="type-text">
                            <span class="input-title">Application <em> *</em></span>
                        </div>
                        <div class="dropdown-wrap">
                            <app-form-select-box [options]="globalService.appsList" [dropDownIdKey]="'id'" [dropdownLabel]="'list'" [formElementName]="addAlert" [controlName]="'appName_select_name'" [addCurrentSelectedValue]="false" (currentSelectionChange)="changeSelection($event)">
                            </app-form-select-box>
                        </div>
                    </div>
                    <div class="input-wrap">
                        <span class="input-title">Application Version</span>
                        <div class="dropdown-wrap">
                            <ng-multiselect-dropdown [placeholder]="'Select'" [data]="globalService.multiSelectAppVersion" formControlName="appVersionArray" [settings]="dropdownSettings">
                            </ng-multiselect-dropdown>

                            <!-- <app-form-select-box  [options]="globalService.ApplicationVersionList"
                        [dropDownIdKey]="'id'" [dropdownLabel]="'list'"
                        [isAllOptionShow]="true"
                        [formElementName]="addAlert" [controlName]="'appVersion_select_name'"
                        [addCurrentSelectedValue]="false"
                        (currentSelectionChange)="changeSelection($event)">
                    </app-form-select-box> -->
                        </div>
                    </div>

                </div>
                <div class="input-row input-row-wide">
                    <div class="input-wrap">
                        <span class="input-title">Location</span>
                        <div class="dropdown-wrap">
                            <ng-multiselect-dropdown [placeholder]="'Select'" [data]="globalService.dropdownList" formControlName="locationArray" [settings]="dropdownSettings">
                            </ng-multiselect-dropdown>
                            <!-- <app-form-select-box [options]="globalService.locationList"
                    [dropDownIdKey]="'id'" [dropdownLabel]="'list'"
                    [formElementName]="addAlert" [controlName]="'location_select_name'"
                    [addCurrentSelectedValue]="false" (currentSelectionChange)="changeSelection($event)">
                </app-form-select-box>  -->
                        </div>
                    </div>
                    <div class="input-wrap">
                        <span class="input-title">Network</span>
                        <div class="dropdown-wrap">
                            <ng-multiselect-dropdown [placeholder]="'Select'" [data]="globalService.multiSelectNetwork" formControlName="operatorArray" [settings]="dropdownSettings">
                            </ng-multiselect-dropdown>
                            <!-- <app-form-select-box  [options]="globalService.networkList"
                    [dropDownIdKey]="'id'" [dropdownLabel]="'list'"
                    [isAllOptionShow]="true"
                    [formElementName]="addAlert" [controlName]="'operator_select_name'"
                    [addCurrentSelectedValue]="false"
                    (currentSelectionChange)="changeSelection($event)">
                </app-form-select-box> -->
                        </div>
                    </div>
                    <div class="input-wrap">
                        <span class="input-title">Speed</span>
                        <div class="dropdown-wrap">
                            <ng-multiselect-dropdown [placeholder]="'Select'" [data]="globalService.multiSelectSpeed" formControlName="downloadSpeedArray" [settings]="dropdownSettings">
                            </ng-multiselect-dropdown>
                            <!-- <app-form-select-box  [options]="globalService.speedList"
                        [dropDownIdKey]="'id'" [dropdownLabel]="'list'"
                        [isAllOptionShow]="true"
                        [formElementName]="addAlert" [controlName]="'downloadSpeed_select_name'"
                        [addCurrentSelectedValue]="false"
                        (currentSelectionChange)="changeSelection($event)">
                    </app-form-select-box> -->
                        </div>
                    </div>
                </div>
                <div class="input-row input-row-wide">
                    <div class="input-wrap">
                        <span class="calendar-icon"></span>
                        <span class="input-title">From Date</span>
                        <div class="datepicker-container">
                            <ng-datepicker (ngModelChange)="dateSelect($event)" formControlName="startDate" name="startDate" [options]="optionsStartDate"></ng-datepicker>
                        </div>
                    </div>
                    <div class="input-wrap">
                        <span class="calendar-icon"></span>
                        <span class="input-title">To Date</span>
                        <div class="datepicker-container">
                            <ng-container *ngIf="fromdateSelected">
                                <div class="datepicker-container">
                                    <ng-datepicker formControlName="endDate" name="endDate" [options]="optionsEndDate"></ng-datepicker>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="!fromdateSelected">
                                <div class="datepicker-container">
                                    <ng-datepicker [options]="optionsEndDate" name="endDate"></ng-datepicker>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                    <div class="input-wrap">
                        <span class="input-title">Time Window</span>
                        <div class="dropdown-wrap">
                            <ng-multiselect-dropdown [placeholder]="'Select'" [data]="globalService.multiSelectTimeWindow" formControlName="timeWindowArray" [settings]="dropdownSettings">
                            </ng-multiselect-dropdown>
                            <!-- <app-form-select-box  [options]="globalService.timeWindowList"
                            [dropDownIdKey]="'id'" [dropdownLabel]="'list'"
                            [isAllOptionShow]="true"
                            [formElementName]="addAlert" [controlName]="'timeWindow_select_name'"
                            [addCurrentSelectedValue]="false"
                            (currentSelectionChange)="changeSelection($event)">
                        </app-form-select-box> -->
                        </div>
                    </div>
                </div>
                <div class="input-row input-row-wide">
                    <div class="input-wrap">
                        <span class="input-title">Device Catagory</span>
                        <div class="dropdown-wrap">
                            <ng-multiselect-dropdown [placeholder]="'Select'" [data]="globalService.multiSelectDeviceCategory" formControlName="deviceCategoryArray" [settings]="dropdownSettings">
                            </ng-multiselect-dropdown>
                            <!-- <app-form-select-box  [options]="globalService.deviceCategoryList"
                [dropDownIdKey]="'id'" [dropdownLabel]="'list'"
                [isAllOptionShow]="true"
                [formElementName]="addAlert" [controlName]="'deviceCategory_select_name'"
                [addCurrentSelectedValue]="false"
                (currentSelectionChange)="changeSelection($event)">
            </app-form-select-box> -->
                        </div>
                    </div>
                    <!-- <div class="input-wrap input-choice">
                    <span class="input-title">Stream Type</span>                
                    <div class="check-bar" >								
                        <div class="check check-radio">
                            <label class="custom-checkbox">
                                <input type="radio"    value="true"  formControlName="stream"  name="stream" required>
                                <em class="checkmark"></em>
                                <span class="check-text">Live</span>
                            </label>
                        </div>
                        <div class="check check-radio">
                            <label class="custom-checkbox">
                                <input type="radio"   value="false"  formControlName="stream"  name="stream"  required>
                                <em class="checkmark"></em>
                                <span class="check-text">VOD</span>
                            </label>
                        </div>								
                    </div>
                </div> -->
                </div>
                <div class="popup-links text-right">
                    <button class="btn btn-light" (click)="forPopupClose()">close</button>
                    <button class="btn btn-dark" (click)="addNewAlert()">create alerts</button>
                </div>
            </form>
        </div>
    </div>
</div>